<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">

				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">{{$route.name}}</h4>
						<!-- <p class="category">{{$route.name}}</p> -->
					</md-card-header>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-60">
								<div class="md-layout-item md-small-size-100 md-size-100">
									<h3>ព័ត៌មានអំពីកញ្ចប់ឥវ៉ាន់</h3>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100 text-right">
									<span class="late">* តម្រូវឱ្យបំពេញ</span>
								</div>
								<div class="md-layout">
									<div class="md-layout-item md-small-size-100 md-size-33">
										<label>ប្រភេទឥវ៉ាន់ *</label>
										<v-select label="name" inputId="id" :clearable="false" :options="packageTypeList"
											v-model="package.packageTypeArray">
										</v-select>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-33">
										<label>ទីតាំងតំបន់ *</label>
										<v-select label="name" inputId="id" :clearable="false" :options="locationList"
											v-model="package.locationArray">
										</v-select>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-33">
										<label>អ្នកទៅទទួលកញ្ចប់ *</label>
										<v-select label="name" inputId="id" :clearable="false" :options="driverList"
											v-model="package.driverArray">
										</v-select>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-33">
										<md-field>
											<label>ប្រភេទប្រាក់ *</label>
											<md-select placeholder="ប្រភេទប្រាក់ *" v-model="package.price_currency">
												<md-option value="usd">ដុល្លា</md-option>
												<md-option value="khr">រៀល</md-option>
											</md-select>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-33">
										<md-field>
											<label>តម្លៃឥវ៉ាន់ *</label>
											<md-input type="number" v-model="package.price"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-33">
										<md-field>
											<label>ថ្លៃដឹកជញ្ជូន *</label>
											<md-input type="number" v-model="package.fee" disabled="disabled"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-33">
										<md-field>
											<label>លេខទូរស័ព្ទអ្នកទទួល *</label>
											<md-input type="text" v-model="package.receiver_phone"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-33">
										<md-field>
											<label>អ្នកបង់ថ្លៃដឹកជញ្ជូន *</label>
											<md-select placeholder="អ្នកបង់ថ្លៃដឹកជញ្ជូន *" v-model="package.fee_responsible">
												<md-option value="rcv">អ្នកទទួល</md-option>
												<md-option value="snd">អ្នកផ្ញើ</md-option>
											</md-select>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-33">
										<md-field>
											<label>កំណត់ចំណាំផ្សេងៗសម្រាប់ក្រុមហ៊ុន</label>
											<md-input type="text" v-model="package.note"></md-input>
										</md-field>
									</div>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<h3>ព័ត៌មានអំពីអ្នកផ្ញើ</h3>
								</div>
								<div class="md-layout">
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ស្វែងរកអ្នកផ្ញើតាម លេខទូរស័ព្ទ ឬ ID *</label>
											<md-input type="text" v-model="clientSearchText" @keyup.enter="searchHandler()">
											</md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-30">
										<md-button class="md-raised md-primary" @click="searchHandler()">ស្វែងរក</md-button>
									</div>
									<!-- <div class="md-layout-item md-small-size-100 md-size-20">
										(មិនមាន)
									</div> -->
									<div class="md-layout-item md-small-size-100 md-size-100">
										<md-table>
											<md-table-row v-for="(client, index) in clientList.slice(0,3)">
												<md-table-cell>
													<img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px">
													<b>ID: {{client.hash_id}}</b> ({{client.name}}, {{client.phone}})
												</md-table-cell>
												<md-table-cell class="text-right">
													<md-button class="md-just-icon md-simple md-success" @click="">
														<md-icon>add</md-icon>
														<md-tooltip md-direction="top">ដាក់អ្នកដឹកជញ្ជូន</md-tooltip>
													</md-button>
												</md-table-cell>
											</md-table-row>
										</md-table>
									</div>
								</div>

							</div>
							<div class="md-layout-item md-small-size-100 md-size-40">
								<div class="md-layout-item md-small-size-100 md-size-100">
									<h3>ព័ត៌មានសង្ខេប</h3>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-table>
										<md-table-row>
											<md-table-cell style="width: 50%;">ប្រភេទឥវ៉ាន់</md-table-cell>
											<md-table-cell style="width: 5px">៖</md-table-cell>
											<md-table-cell>
												<span v-if="String(package.type).length > 0">{{package.type}}</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>ទីតាំងតំបន់</md-table-cell>
											<md-table-cell>៖</md-table-cell>
											<md-table-cell>
												<span v-if="String(package.location_id).length > 0">{{package.location}}</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>តម្លៃឥវ៉ាន់</md-table-cell>
											<md-table-cell>៖</md-table-cell>
											<md-table-cell>
												<span
													v-if="String(package.price).length > 0 && String(package.price_currency).length > 0 && String(package.price_status).length > 0">{{config.moneylify(package.price,
													package.price_currency)}}</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>ថ្លៃដឹកជញ្ជូន</md-table-cell>
											<md-table-cell>៖</md-table-cell>
											<md-table-cell>
												<span
													v-if="String(package.fee).length > 0 && String(package.fee_currency).length > 0 && String(package.fee_status).length > 0">{{config.moneylify(package.fee,
													package.fee_currency)}}
													<span v-if="String(package.fee_responsible).length > 0">អ្នកបង់:
														{{config.getStatus(package.fee_responsible)}}</span></span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>លេខទូរស័ព្ទអ្នកផ្ញើ</md-table-cell>
											<md-table-cell>៖</md-table-cell>
											<md-table-cell>
												<span v-if="String(package.client_id).length > 0">
													<span>{{package.client_phone}} ({{package.client_name}})</span>
													<span @click="removeClient()" style="color:red;cursor: pointer;"> ដកចេញ</span>
												</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>លេខទូរស័ព្ទអ្នកទទួល</md-table-cell>
											<md-table-cell>៖</md-table-cell>
											<md-table-cell>
												<span
													v-if="String(package.receiver_phone).length > 0">{{package.receiver_phone}}</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>កំណត់ចំណាំផ្សេងៗសម្រាប់ក្រុមហ៊ុន</md-table-cell>
											<md-table-cell>៖</md-table-cell>
											<md-table-cell>
												<span v-if="String(package.note).length > 0">{{package.note}}</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
									</md-table>
								</div>
							</div>
							<div class="md-layout-item md-size-100 text-right">
								<md-button class="md-raised md-primary" @click="createPackage()">ដាក់បញ្ចូល</md-button>
							</div>
						</div>
						<!-- <v-select label="name" inputId="id" :options="locationList" v-model="package.location_id"></v-select>
										{{package.location_id}} -->
					</md-card-content>
				</md-card>
			</div>

		</div>

		<md-dialog-confirm :md-active.sync="newClientDialog"
			md-title="អ្នកមិនទាន់មានអតិថិជននេះនៅក្នុងប្រព័ន្ធទេ សូមបង្កើតថ្មី។" md-confirm-text="ទៅកាន់ផ្ទាំងបង្កើតអតិថិជន"
			md-cancel-text="បិទ" @md-cancel="close" @md-confirm="goClient" />
	</div>
</template>

<script>
	export default {
		components: {
		},
		mounted() {
			if (!this.allow_user('sa|ca')) { this.$router.push("/404"); }
			if (this.$store.state.authentication.mode != "normal") { this.$router.push("/404"); }
		},
		created() {
			this.getSettings();
		},
		data() {
			return {
				package: {
					locationArray: "",
					packageTypeArray: "",
					driverArray: "",
					type: "",
					location_id: "",
					location: "",
					price: "",
					price_currency: "usd",
					fee: "",
					fee_currency: "usd",
					fee_responsible: "snd",
					client_id: "",
					driver_pickup_id: "",
					client_name: "",
					client_phone: "",
					// sender_phone: "",
					receiver_phone: "",
					note: ""
				},
				newClientDialog: false,
				packageTypeList: [],
				clientList: [],
				driverList: [],
				clientSearchText: "",
				locationList: []
			}
		},
		watch: {
			// 'package.fee': function (val) {
			// 	if (parseInt(val) >= 2.5) {
			// 		this.package.fee_currency = "khr";
			// 		if(parseFloat(val) > 10000) {
			// 			this.package.fee = 10000;
			// 		};
			// 		console.log(val);
			// 	} else {
			// 		this.package.fee_currency = "usd";
			// 		if(parseFloat(val) > 2.5) this.package.fee = 2.5;
			// 	}
			// },
			// 'package.fee_currency': function(val) {
			// 	if(val == "khr") {
			// 		if (this.package.fee > 10000) {
			// 			this.package.fee = 10000;
			// 		}
			// 	} else {
			// 		if(this.package.fee > 2.5) {
			// 			this.package.fee = 2.5;
			// 		}
			// 	}
			// },
			'package.price_currency' : function(val) {
				if(val == "khr") {
					this.package.fee_currency = "khr";
					this.package.fee = 5000;
				} else {
					this.package.fee_currency = "usd";
					this.package.fee = 1.25;
				}
			},
			'package.price': function (val) {
				if (parseInt(val) > 1000) {
					this.package.price_currency = "khr";
					this.package.fee_currency = "khr";
					this.package.fee = 5000;
				} else {
					this.package.price_currency = "usd";
					this.package.fee_currency = "usd";
					this.package.fee = 1.25;
				}
			},
			'package.locationArray': function (val) {
				if (String(this.package.locationArray).length > 5) {
					this.package.location_id = this.package.locationArray.id;
					this.package.location = this.package.locationArray.name;
				} else {
					this.package.location_id = "";
					this.package.location = "";
				}
			},
			'package.packageTypeArray': function (val) {
				if (String(this.package.packageTypeArray).length > 5) {
					this.package.type = this.package.packageTypeArray.name;
				} else {
					this.package.type = "";
				}
			},
			'package.driverArray': function (val) {
				if (String(this.package.driverArray).length > 5) {
					this.package.driver_pickup_id = this.package.driverArray.id;
				} else {
					this.package.driver_pickup_id = "";
				}
			}
		},
		computed: {
			getLocation() {
				if (this.package.locationArray != 'undefined') {
					this.package.location_id = this.package.locationArray.id;
					this.package.location = this.package.locationArray.name;
					// for (let i = 0; i < this.locationList.length; i++) {
					// 	if (this.package.location_id == this.locationList[i].id) {
					// 		this.package.location = this.locationList[i].name;
					// 		return this.locationList[i].name;
					// 	}
					// }
				} else {
					return "មានបញ្ហា"
				}
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.packageTypeList = data.body.data.package_type
					this.locationList = data.body.data.location
					this.getDriver();
				})
			},
			getDriver(more = false) {
				this.$http.post(this.config.api + "/admin/driver/search", {
					text: "",
					status: "act",
					offset: 0
				}).then(data => {
					this.driverList = data.body.data;
				})
			},

			searchHandler(more = false) {
				if (String(this.clientSearchText).length < 3) return;
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.clientSearchText,
					offset: more ? this.clientList.length : 0
				}).then(data => {
					// this.clientSearchText = "";
					if (data.body.data.length === 1) {
						this.package.client_id = data.body.data[0].id
						this.package.client_name = data.body.data[0].name
						this.package.client_phone = data.body.data[0].phone
						this.$notification.notify({
							message: "បានដាក់អតិថិជនចូលជាម្ចាស់កញ្ចប់ឥវ៉ាន់។",
							icon: 'done',
							type: 'success'
						})
						this.clientSearchText = "";
					} else if (data.body.data.length > 1) {
						this.$notification.notify({
							message: "ស្វែងរកមិនត្រឹមត្រូវសូមស្វែងរកម្តងទៀត។",
							icon: 'error',
							type: 'danger'
						})
					} else {
						this.newClientDialog = true;
						// this.$notification.notify({
						// 	message: "មិនមានអតិថិជននេះទេ សូមបង្កើតថ្មី។",
						// 	icon: 'error',
						// 	type: 'danger'
						// });
					}
				})
			},
			removeClient() {
				this.package.client_id = "";
				this.package.client_name = ""
				this.package.client_phone = ""
			},
			createPackage() {
				if (this.checkValidation()) {
					this.$http.post(this.config.api + "/admin/package/post", {
						package: this.package
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "កញ្ចប់ឥវ៉ាន់ត្រូវបានដាក់បញ្ចូលដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							let hash_id = res.body.data.hash_id;
							let tracking = res.body.data.package_id;

							this.$http.get(this.config.api + "/admin/package/get/" + res.body.data.hash_id).then(data => {

								let driver_phone = encodeURIComponent(data.body.data.driver_phone || "មិនមាន");
								let receiver_phone = encodeURIComponent(this.package.receiver_phone);
								let sender_phone = encodeURIComponent(this.package.client_phone);
								let client_name = encodeURIComponent(this.package.client_name || "មិនមាន");
								let location = encodeURIComponent(this.package.location);
								let package_price = this.package.price == 0 ? "ទូទាត់រួច" : encodeURIComponent(this.config.moneylify(this.package.price, this.package.price_currency));
								let fee = this.package.fee_responsible == "snd" ? "ទូទាត់រួច" : encodeURIComponent(this.config.moneylify(this.package.fee, this.package.fee_currency));
								this.$http.get(`https://localhost:8084/print?hash_id=${hash_id}&tracking=${tracking}&sender_phone=${sender_phone}&receiver_phone=${receiver_phone}&driver_phone=${driver_phone}&package_price=${package_price}&delivery_fee=${fee}&location=${location}&sender_name=${client_name}`).then(data => {

								})
								var self = this;
								setTimeout(() => {
									self.$router.push("/packages");
								}, 1000)
							})

							// window.open("http://localhost:8084/print?hash_id=qweqwe&tracking=ONE202128574657&sender_phone=${this.package.client_phone}&receiver_phone=${this.package.receiver_phone}&driver_phone=012121212%20012958684&package_price=5000&delivery_fee=%E1%9E%91%E1%9E%BC%E1%9E%91%E1%9E%B6%E1%9E%8F%E1%9F%8B%E1%9E%9A%E1%9E%BC%E1%9E%85&location=%E1%9E%9F%E1%9F%86%E1%9E%9A%E1%9F%84%E1%9E%84%E1%9E%A2%E1%9E%8E%E1%9F%92%E1%9E%8A%E1%9F%82%E1%9E%8F")
							// this.$router.push("/packages");
							// this.tabName = 'first';


							// this.getSettings();

						}
					})
				} else {
					this.$notification.notify({
							message: "ព័ត៌មានមិនគ្រប់។",
							icon: 'error',
							type: 'danger'
						});
				}
			},
			close() {
				this.newClientDialog = true;
			},
			goClient() {
				window.open("/#/clients", '_blank');
			},
			checkValidation() {
				if (String(this.package.type_id).length > 0 &&
					String(this.package.location_id).length > 0 &&
					String(this.package.price).length > 0 &&
					String(this.package.price_currency).length > 0 &&
					String(this.package.fee).length > 0 &&
					String(this.package.fee_currency).length > 0 &&
					String(this.package.fee_responsible).length > 0 &&
					String(this.package.sender_phone).length > 0 &&
					String(this.package.receiver_phone).length > 0 &&
					String(this.package.driver_pickup_id).length > 0) {
					return true;
				} else {
					return false;

				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/NewPackage.vue